/**
 * ObjectFieldSupplement React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// application components
import ObjectMediaURLSupplement from "./ObjectMediaURLSupplement";


// define components for different field types
const supplementComponents = {
    mediaurl: ObjectMediaURLSupplement
};


/**
 * ObjectFieldSupplement is a React component representing the supplement component (shown right) for a single object property
 *
 * @author Jens Gruschel
 */
export class ObjectFieldSupplement extends React.Component {

    render() {

        const Element = supplementComponents[this.props.fieldDef.type];

        if (Element) {
            const fieldProps = {
                fieldDef: this.props.fieldDef,
                objectId: this.props.objectId,
                value: this.props.value,
                suffix: this.props.suffix,
                scope: this.props.scope,
                readOnly: this.props.readOnly,
                onObjectValueChange: this.props.onObjectValueChange
            };
            return <Element {...fieldProps} />;
        }
        else {
            return null;
        }
    }
}

ObjectFieldSupplement.propTypes = {
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    value: PropTypes.any,
    readOnly: PropTypes.bool,
    onObjectValueChange: PropTypes.func.isRequired
};

export default ObjectFieldSupplement;